import { Container, Grid } from "@mui/material";
import React from "react";
import Cards from "../components/cards";
import styled from "@emotion/styled";

const EndGrid  = styled(Grid)`
    padding: 8% 0px 3%;
    @media (min-width: 900px) and (max-width: 1200px){
        padding: 15% 0px 3%;
    }
    @media (min-width: 1200px) and (max-width: 1500px){
        padding: 10% 0px 3%;
    }
    @media (min-width: 1800px){
        padding: 5% 0px 3%;
    }
    @media (min-width: 600px) and (max-width: 750px){
        padding: 5% 0px 3%;
    }
`
const HeaderEnd = () => {
    return(
        <Container maxWidth='lg'>
            <EndGrid container spacing={2}>
                <Grid xs={12} sm={6} md={4} p = {1}>
                    <Cards
                        name='$200,000'
                        desc = 'Trading Volume'
                    />
                </Grid>
                <Grid xs={12} sm={6} md={4} p = {1}>
                    <Cards
                        name='3,000'
                        desc = 'Unique Address'
                    />
                </Grid>
                <Grid xs={12} sm={6} md={4} p = {1}>
                    <Cards
                        name='20X'
                        desc = 'Alerts Sent'
                    />
                </Grid>
                {/* <Grid xs={12} md={3} sm={6} p = {1}>
                    <Cards
                        name='3'
                        desc = 'Available Pairs'
                    />
                </Grid>   */}
            </EndGrid>
        </Container>
    )
}

export default HeaderEnd